// src/components/graphs/ImpressionScatterplotGraph.js

import React, { useEffect, useState } from "react";
import Plot from "react-plotly.js";
import { Card, CircularProgress, Typography } from "@mui/material";
import { getImpressionScatterplotData } from "../../../../../apis/plans.apis"; // <-- Assumes a new API function

const ImpressionScatterplot = ({ billboardId }) => {
  const [scatterplotData, setScatterplotData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        
        const data = await getImpressionScatterplotData(billboardId);
        
        const formattedData = data
          .map((item) => {
            let hour = item.time;
            if (typeof hour === "string" && hour.includes(":")) {
              hour = parseInt(hour.split(":")[0], 10);
            }
            const nextHour = hour + 1;
            const label = `${String(hour).padStart(2, "0")}:00-${String(
              nextHour
            ).padStart(2, "0")}:00`;

            return {
              hour,
              // 2. Use the 'impressions' field from your data
              impressions: Number(item.impressions), 
              label,
            };
          })
          .filter((d) => d.hour >= 7 && d.hour <= 22);

        setScatterplotData(formattedData);
      } catch (error) {
        console.error("Error fetching impression scatterplot data:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [billboardId]);

  // 3. Update the graph trace to use impression data
  const trace = {
    x: scatterplotData.map((d) => d.label),
    y: scatterplotData.map((d) => d.impressions), // Use impressions for Y-axis
    mode: "markers",
    type: "scatter",
    marker: {
      size: 12,
      color: scatterplotData.map((d) => d.impressions), // Color by impression count
      colorscale: "Viridis", // A different colorscale to distinguish
      colorbar: {
        title: "Impressions", // Updated colorbar title
      },
    },
    name: "Impressions",
  };

  return (
    <Card sx={{ p: 2, borderRadius: 2 }}>
      {/* 4. Update the main title */}
      <Typography variant="h6" textAlign="center">
        Scatterplot: Impressions Over Time
      </Typography>
      {loading ? (
        <CircularProgress sx={{ display: "block", margin: "20px auto" }} />
      ) : (
        <Plot
          data={[trace]}
          layout={{
            height: 400,
            margin: { t: 30, l: 50, r: 30, b: 70 },
            xaxis: {
              title: "Hour Interval",
              type: "category",
              tickangle: -45,
            },
            yaxis: {
              // 5. Update the Y-axis title
              title: "Number of Impressions", 
            },
          }}
          style={{ width: "100%", height: "100%" }}
          useResizeHandler
          config={{
            responsive: true,
            displaylogo: false,
            displayModeBar: true,
          }}
        />
      )}
    </Card>
  );
};

export default ImpressionScatterplot;